import { SidebarTrigger, useSidebar } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import text_logo from "@assets/images/text_logo.svg";
import logo from "@assets/images/logo.svg";
import { useAppState } from "@/modules/app/useAppContext";

export const SidebarHeader = () => {
  const { open } = useSidebar();
  const { hideSidebarExpandIcon } = useAppState();

  return (
    <Stack
      justify={"between"}
      align={"center"}
      className="al-h-10"
    >
      <img src={open ? text_logo : logo} alt="Altimate AI" className={open ? "al-ml-4" : ""} />
      {open && !hideSidebarExpandIcon && <SidebarTrigger />}
    </Stack>
  );
};